import { HEADERS } from "./headers.constants";

export const HEADERS_AUTHENTICATED: HeadersInit = HEADERS;
